import axios, { getStandardAxiosConfig } from '../util/api';

class AdminAPI {
  static fetchCows () {
    return axios.get('/admin/cattle', getStandardAxiosConfig());
  }
  static fetchCow (id) {
    return axios.get(`/admin/cattle/${id}`, getStandardAxiosConfig());
  }
  static addCow (cow) {
    return axios.post(
      '/admin/cattle',
      { ...cow },
      getStandardAxiosConfig()
    );
  }
  static updateCow (cow) {
    return axios.put(
      `/admin/cattle/${cow.id}`,
      { ...cow },
      getStandardAxiosConfig()
    );
  }
  static deleteCow (cow) {
    return axios.delete(
      `/admin/cattle/${cow.id}`,
      getStandardAxiosConfig()
    );
  }
  static slaughterAnimals (
    animalIds, slaughterDate, cuttingDate, slaughterHouseId, cuttingPlantId
  ) {
    const params = { animalIds };
    if (cuttingDate) params.date = cuttingDate;
    if (slaughterDate) params.date = slaughterDate;
    if (slaughterHouseId) params.slaughterHouseId = slaughterHouseId;
    if (cuttingPlantId) params.cuttingPlantId = cuttingPlantId;
    return axios.put(
      '/admin/cattle/actions/slaughter-cattle',
      params,
      getStandardAxiosConfig()
    );
  }
  /**
   * The id must be the id of an org - it's used by the api
   * to establish permissions
   */
  static saveFile (id, fileName, file, onProgress) {
    const name = encodeURIComponent(fileName);
    const data = new window.FormData();
    data.append('file', file);
    const config = getStandardAxiosConfig();
    config.headers['Content-Type'] = 'multipart/form-data';
    config.onUploadProgress = onProgress;
    return axios.post(
      `/admin/file?fileName=${name}&id=${id}`,
      data,
      config
    );
  }
  static deleteDocument (path) {
    return axios.delete(
      `/admin/file?object=${path}`,
      getStandardAxiosConfig()
    );
  }
  static deleteDocuments (files) {
    return axios.delete(
      `/admin/files`,
      {
        ...getStandardAxiosConfig(),
        data: { files }
      }
    );
  }
  static registerUser (user) {
    return axios.post(
      `/users/register`,
      user
    );
  }
  static confirmRegistration (authCode, id) {
    return axios.post(
      `/users/confirm-email`,
      { authCode, id }
    );
  }
  static updatePassword (email, existingPassword, newPassword) {
    return axios.post(
      `/users/update-password`,
      { email, existingPassword, newPassword },
      getStandardAxiosConfig()
    );
  }
  static setPassword (authCode, id, password) {
    return axios.post(
      `/users/set-password`,
      { authCode, id, password }
    );
  }
  static requestPasswordReset (email) {
    return axios.post(
      `/users/forgot-password`,
      { email }
    );
  }
}

export default AdminAPI;
